'use client';
import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/navigation';
import Sidebar from './Sidebar';

interface AppLayoutProps {
  children: React.ReactNode;
}

export default function AppLayout({ children }: AppLayoutProps) {
  const router = useRouter();
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    const token = window.localStorage.getItem('auth_token') ?? window.sessionStorage.getItem('auth_token');

    if (!token) {
      router.replace('/sign-up-login-screen');
      setIsAuthenticated(false);
      return;
    }

    setIsAuthenticated(true);
  }, [router]);

  if (!isAuthenticated) return null;

  return (
    <div data-component-id="src/components/AppLayout.tsx:30:4" data-component-path="src/components/AppLayout.tsx" data-component-line="30" data-component-end-line="44" data-component-file="AppLayout.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20h-screen%20overflow-hidden%20bg-%5B%23f5f5f5%5D%22%7D" className="flex h-screen overflow-hidden bg-[#f5f5f5]">
      <Sidebar data-component-id="src/components/AppLayout.tsx:31:6" data-component-path="src/components/AppLayout.tsx" data-component-line="31" data-component-end-line="34" data-component-file="AppLayout.tsx" data-component-name="Sidebar" data-component-content="%7B%22elementName%22%3A%22Sidebar%22%7D"
        collapsed={sidebarCollapsed}
        onToggle={() => setSidebarCollapsed((v) => !v)}
      />
      <main data-component-id="src/components/AppLayout.tsx:35:6" data-component-path="src/components/AppLayout.tsx" data-component-line="35" data-component-end-line="43" data-component-file="AppLayout.tsx" data-component-name="main" data-component-content="%7B%22elementName%22%3A%22main%22%7D"
        className={`flex-1 overflow-y-auto transition-all duration-300 ease-in-out ${
          sidebarCollapsed ? 'ml-0' : 'ml-0'
        }`}
      >
        <div data-component-id="src/components/AppLayout.tsx:40:8" data-component-path="src/components/AppLayout.tsx" data-component-line="40" data-component-end-line="42" data-component-file="AppLayout.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22min-h-full%20w-full%20max-w-screen-2xl%20mx-auto%20px-6%20lg%3Apx-8%20xl%3Apx-10%20py-8%22%7D" className="min-h-full w-full max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-8">
          {children}
        </div>
      </main>
    </div>
  );
}